import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  Button,
  Box,
  Grid
} from "@mui/material";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import AutohideSnackbar from "../LayoutModule/autohideSnackbar";
import AppGlobalStaticData from "../../appdata/appStaticData";
import useCaseHistoryAPIDetails from "../../api/caseHistoryAPIDetails";
const CaseHistoryForm = ({ id,caseid, onClose }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [casesHistory, setCasesHistory] = useState({
    id:0,
    case_id: caseid,
    hearing_message: "",
    updated_by: "1",
    hearing_date: "",
  });

  const [snackbarProperties, setSnackbarProperties] = useState({
    duration: 0,
    message: "",
    serverity: "",
  });

  const isSubmitting = useRef(false); // useRef to manage form submission state
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCasesHistory({
      ...casesHistory,
      [name]: value,
    });
  };

 useEffect(() => {
    if (id) {
    getCaseHistoryID(id);
    }},[id])

  const { addNewCaseHistory, getCaseHistoryData, loading } = useCaseHistoryAPIDetails()

   const globalData = new AppGlobalStaticData();

   const getCaseHistoryID = async (id) =>{

    await getCaseHistoryData(id,(response) => {
      console.log(response);
      setCasesHistory(response[0]);
    },
    (errorMessage) => {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: errorMessage,
        serverity: globalData.SeverityError,
      });
    })

   }
  const handleSubmit = async (e) => {
    e.preventDefault();
    await addNewCaseHistory (
      id,
      casesHistory,
      (response) => {
        onClose();
        setSnackbarProperties({
          duration: globalData.Duration,
          message: id ? globalData.EditCaseSuccess : globalData.AddCaseSuccess,
          serverity: globalData.SeveritySuccess,
        });
      },
      (errorMessage) => {
        setSnackbarProperties({
          duration: globalData.Duration,
          message: errorMessage,
          serverity: globalData.SeverityError,
        });
      }
    );
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              rows={4}
              multiline
              label="Status"
              name="hearing_message"
              value={casesHistory.hearing_message}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <DatePickerComponent
              placeholder="Hearing Date"
              name="prevDate"
              value={casesHistory.hearing_date}
              onChange={(e) =>
                setCasesHistory({
                  ...casesHistory,
                  hearing_date: e.target.value,
                })
              }
              format="dd/MM/yyyy"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Box mt={2}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                disabled={isSubmitting.current}
              >
                {id ? "Update" : "Create"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
      <AutohideSnackbar
        open={snackbarOpen}
        duration={snackbarProperties.duration}
        message={snackbarProperties.message}
        severity={snackbarProperties.serverity}
        handleClose={handleSnackbarClose}
      ></AutohideSnackbar>
    </>
  );
};

export default CaseHistoryForm;
